import { Link } from 'wouter';
import type { Bucket } from '../lib/api';
import { needsYou, runLine, type Run } from '../lib/approving';
import { cardHref } from './Rail';
import './runstray.css';

/**
 * fix-79: the approvals still running on the desk, while he works the next card. One line each — "Activating…
 * Update-IOU-Limit", "Sent in 3.1 s" — an ending that needs nothing leaves by itself; a failure stays, with the card.
 */
export function RunsTray({ runs, bucket, onClose }: { runs: Run[]; bucket: Bucket; onClose: (id: number) => void }) {
  if (!runs.length) return null;
  return (
    <aside className="runs" aria-label="Approvals running" aria-live="polite">
      {runs.map((r) => {
        const tone = needsYou(r) ? 'rust' : r.phase === 'waiting' || r.phase === 'continues' || r.slow ? 'amber' : r.phase === 'running' ? 'ink' : 'teal';
        return (
          <div key={r.id} className={`run run-${tone}`}>
            <span className={`run-dot ${r.phase === 'running' ? 'is-live' : ''}`} aria-hidden="true" />
            <div className="run-text">
              <span className="run-who">{r.who}</span>
              <span className="run-line mono">{runLine(r)}</span>
            </div>
            {r.phase !== 'running' && (
              <>
                {needsYou(r) && <Link href={cardHref(bucket, r.id)} className="run-open" onClick={() => onClose(r.id)}>Open</Link>}
                <button type="button" className="run-close" aria-label="Close" onClick={() => onClose(r.id)}>×</button>
              </>
            )}
          </div>
        );
      })}
    </aside>
  );
}
